function myFunction(button) {
  var copyText, copyContainer, copiedMessage;
  
  if (button) {
    // クラスベースの構造用
    var container = button.closest('.copy-container');
    copyText = container.querySelector('.copy-input');
    copyContainer = container.querySelector('.copy-button-container');
    copiedMessage = container.querySelector('.copied-message');
  } else {
    // IDベースの構造用
    copyText = document.getElementById("myInput");
    copyContainer = document.getElementById("copyContainer");
    copiedMessage = document.getElementById("copiedMessage");
  }

  // テキストエリアを作成してコピー
  var textArea = document.createElement("textarea");
  textArea.value = copyText.value;
  document.body.appendChild(textArea);
  textArea.select();
  
  try {
    var successful = document.execCommand('copy');
    if (successful) {
      // コピー成功時の処理
      copyContainer.style.display = "none";
      copiedMessage.style.display = "block";
      
      setTimeout(function() {
        copyContainer.style.display = "block";
        copiedMessage.style.display = "none";
      }, 1000);
    } else {
      console.error('コピーに失敗しました');
    }
  } catch (err) {
    console.error('コピー中にエラーが発生しました', err);
  }
  
  // 一時的に作成したテキストエリアを削除
  document.body.removeChild(textArea);
}